/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 15:44:56
 * @LastEditTime: 2022-01-03 14:27:18
 * @LastEditors: wangshengqiang
 * @Description: 投保人信息确认
 */

/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { useStore } from '@/store';
import { transFormValue, DetailItem } from '../ConfirmOrderInfo/transformValue';
import ConfirmInfoTitle from '../ConfirmOrderInfo/ConfirmInfoTitle';
import './index.less';

const holderConfirm = props => {
  const {
    attrs,
    label
  } = props;
  const {
    dataSource = [],
    isDefault
  } = attrs;

  if (!isDefault) {
    return null;
  }

  const orderDetail = useStore('orderDetail') || {
    insuredList: []
  };
  const {
    holder
  } = orderDetail || {};
  const {
    person = {}
  } = holder || {}; // 过滤出不需要的确认的项

  const Filter = dataSource.filter(item => item.isDefault === true);

  if (Filter.length === 0) {
    return null;
  }

  const otherList = Filter.filter(item => item.label !== Filter[0].label);
  return /*#__PURE__*/React.createElement("div", {
    id: "infoConfirm",
    className: "c-InfoConfirm bg-fff"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(ConfirmInfoTitle, {
    title: label
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item first"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, Filter[0].label, ":"), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, transFormValue(person[Filter[0].value], Filter[0].dataSource, Filter[0].value))), otherList.map(item => {
    return /*#__PURE__*/React.createElement(DetailItem, {
      itemValue: person[item.value],
      dataSource: item.dataSource,
      itemlabel: item.label,
      itemKey: item.value,
      key: item.value
    });
  })));
};

export default holderConfirm;